import { render, staticRenderFns } from "./serachEnginePage.vue?vue&type=template&id=880fb5d2&scoped=true&"
import script from "./serachEnginePage.vue?vue&type=script&lang=js&"
export * from "./serachEnginePage.vue?vue&type=script&lang=js&"
import style0 from "./serachEnginePage.vue?vue&type=style&index=0&id=880fb5d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880fb5d2",
  null
  
)

export default component.exports